import type { IntercomProps } from "react-use-intercom"

import type { Data } from "@/models/IUserInfo"

export function getIntercomBootProps(data: Data, userId: string | undefined, fromApp: string): IntercomProps {
  const rating = data.rating || 0

  return {
    ...(data.intercom_user_jwt ? {} : {
      email: data.user_email || "no email",
      userId: userId || "no userId",
    }),
    customAttributes: {
      "30-day_orders": data.last_30d_count ?? "Unknown",
      "cross-sell_target_customer": data?.cross_sell_flag ?? "False",
      from_app: fromApp,
      plan: `${data.plan_name || "Unknown"} $${data.plan_price || "0"}`,
      review: rating === 0 ? "no review" : `${rating}-star`,
      review_name: data?.review_name || "no review name",
      shop_name: data.ShopName?.replace("https://", "") ?? "no shopName",
      shopify_store_version: data?.shop_plan_display_name || "Unknown", // Shopify 店铺版本
      protection: data?.protection || "",
      // react-use-intercom 5.x 会将 customAttributes 展开到 boot 顶层。
      ...(data.intercom_user_jwt ? { intercom_user_jwt: data.intercom_user_jwt } : {}),
    },

    name: data.user_name || "no name",
  }
}
